Controller = App.loadClass 'core::Angular/Controller'
string_utils = App.load 'core::utils/string'

class exports.StepsController extends Controller
    constructor: (@scope, @transitions, @service, @state, @modal, @http, @window, @timeout) ->
        super

        @scope.fullpage = true
        @scope.saved = false

        # This is only for if you navigate directly to a survey in the URL
        @service.configLoaded.then () =>
            if _.isEmpty(@service.survey) and @state.params.id and @state.params.step
                @http.get("api/nitrogen-surveys/#{@state.params.id}")
                .then (response) =>
                    @service.year = response.data.year
                    @service.crop = response.data.crop.name
                    @service.survey = response.data

                    @service.gotoStep @state.params.step - 1, @state.params.id, false
                .catch (error) =>
                    @state.go 'fields'


        # "Pop" a browser warning dialog if the user tries to leave before being finished

        # If the user navigates to another state
        @transitionStart = @transitions.onStart {}, ($transition) =>
            # Sometimes we don't want to trigger the warning (e.g. clicking "Add Form" or "Edit Form")
            if not @service.triggerBrowserWarning
                return

            # If we're going to a child state, don't worry about unsaved changes
            if string_utils.startsWith $transition.to().name, @state.current.name
                return

            # If the survey is incomplete, warn the user
            if not @service.surveyComplete()
                if not @window.confirm('You have not completed the N Solver survey. You will not receive VariMax maps for fields with incomplete data.\n\nAre you sure you wish to leave?')
                    return false

            @service.save(@service.stateParams.id)

        # If the user closes the tab
        @window.onbeforeunload = () =>
            @service.save(@service.stateParams.id)

            # If the survey is incomplete, warn the user
            if not @service.surveyComplete()
                # Modern browsers will ignore this message.
                return 'You have unsaved changes.'

            return null # Don't show a warning

        # Deregister the event listeners when the scope is destroyed so we don't create memory leaks
        @scope.$on '$destroy', =>
            @transitionStart()
            @window.onbeforeunload = null

    gotoPrevStep: () =>
        @service.gotoStep(@service.currentStepIndex - 1)

    gotoNextStep: () =>
        @service.nextAttempted = true

        if not @service.stepComplete(@service.currentStepName)
            return

        @service.gotoStep(@service.currentStepIndex + 1)

    saveSurvey: () =>
        @service.nextAttempted = true

        if not @service.stepComplete(@service.currentStepName)
            return

        @service.save(@service.stateParams.id)
        .then () =>
            @scope.saved = true
            # Go here for context about the timeout https://www.pivotaltracker.com/story/show/160768296
            @timeout(() =>
                @state.go 'grower.nsolver', {}, reload: 'grower.nsolver'
            , 2000)

    isOnFirstStep: () =>
        @service.currentStepIndex is 0

    isOnLastStep: () =>
        return false if not @service.config?.steps?
        @service.currentStepIndex is Object.keys(@service.config.steps).length - 1

    numSteps: () =>
        if not @service.config.steps?
            return 0

        Object.keys(@service.config.steps).length
